import { render, staticRenderFns } from "./detail-prix-vente-modal.vue?vue&type=template&id=701232b8&scoped=true"
import script from "./detail-prix-vente-modal.vue?vue&type=script&lang=js"
export * from "./detail-prix-vente-modal.vue?vue&type=script&lang=js"
import style0 from "./detail-prix-vente-modal.vue?vue&type=style&index=0&id=701232b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701232b8",
  null
  
)

export default component.exports